/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {gsap, TimelineLite} from "gsap";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {IndividualWinView} from "./IndividualWinView";
import {Karen} from "../../Karen";
import {KarenGameConfig} from "../../KarenGameConfig";
import {IBetWayWinData} from "../../server/data/IKarenData";
import {KarenParsedGameData} from "../../server/data/KarenParsedGameData";
import {Elastic, TweenLite} from "gsap";
import {KarenSymbol} from "../../symbol/KarenSymbol";

export class IndividualWinController {

    private _view: IndividualWinView;
    private _currentTimeline: TimelineLite | null;
    private _betWaysAll: IBetWayWinData | undefined;
    private _stopped: boolean;
    private _totalWinWaysNum: number;

    constructor() {
        this._view = new IndividualWinView();
    }

    public start(): void {
        this._stopped = false;
        if (Karen.model.parsedGameData?.betWins?.length > 0 && Karen.model.parsedGameData.singleWin > 0) {
            // Add a small delay for the first time so we don't start to play before the autoPlay start next spin.
            if(!Karen.model.parsedGameData.brokeTheBank) {
                new TimelineLite().add(() => this.playNextBetWin(), 1);
            }else{
                Karen.initialCountUp.showToggleWinAmountNWays(Karen.model.parsedGameData.singleWin, 0,false);
            }
        }
    }

    public async stop(): Promise<any> {
        this._stopped = true;
        for (let reelId: number = 0; reelId < 6; reelId++) {
            for (let symInd: number = 0; symInd < Karen.model.parsedGameData.evaluatedArea[reelId].length; symInd++) {
                const sym: KarenSymbol = Karen.reels[reelId].getSymbol(symInd, false, false);
                sym.stopWin();
            }
        }
        if (this._currentTimeline && this._currentTimeline.isActive()) {
            this._currentTimeline.pause();
            this._currentTimeline.kill();
            //await this._currentTimeline.progress(1);
        }
        this._betWaysAll = undefined;
        this._currentTimeline = null;
        await Promise.resolve();
    }

    private playNextBetWin(): void {
        if (this._stopped) {
            return;
        }
        // TODO: reset all win state if needed.

        const data: KarenParsedGameData = Karen.model.parsedGameData;
        const winRatio: number = data.currentWinRatioConfig?.ratio!;
        const winTypeName: string = data.currentWinRatioConfig?.name!;
        const tl: TimelineLite = gsap.timeline();
        // display 1 win group at a time
        if (KarenGameConfig.BET_WIN_MODE === BetWinMode.BET_WAY && !Karen.model.parsedGameData.winBelowStack) {
            (<IBetWayWinData[]>data.betWins).forEach((betWayData: IBetWayWinData) => {
            tl.add(() => Karen.initialCountUp.showToggleWinAmountNWays(betWayData.multipliedAmount, betWayData.numberOfCombinations,true));
            tl.add(this.getBetWayAnimation(betWayData, winTypeName));
        });
        }

        if (data.betWins.length > 1) {
            if (this._betWaysAll === undefined) {
                const allBetWayGroups: IBetWayWinData = JSON.parse(JSON.stringify(data.betWins[0]));

                this._totalWinWaysNum = 0;
                // prepare data for all groups together, we are only interested in "reelWinPositions".
                (<IBetWayWinData[]>data.betWins).forEach((betWayData: IBetWayWinData) => {
                    betWayData.reelWinPositions.forEach((reelWin: boolean[], reelId: number) => {
                        reelWin.forEach((winPosition: boolean, symId: number) => {
                            if (winPosition) {
                                allBetWayGroups.reelWinPositions[reelId][symId] = true;
                            }
                        });
                    });

                    this._totalWinWaysNum += betWayData.numberOfCombinations;
                });
                this._betWaysAll = allBetWayGroups;
            }

            if (this._totalWinWaysNum > 0) {
                tl.add(() => Karen.initialCountUp.showToggleWinAmountNWays(data.singleWin, this._totalWinWaysNum,true));
            }
            tl.add(this.getBetWayAnimation(this._betWaysAll,winTypeName));
        }

        tl.add(() => Karen.initialCountUp.hideToggleWinAmountNWays(true));

        // gap before next iteration starts
        tl.to(this, {duration: 1});

        // next iteration
        tl.add(() => this.playNextBetWin());
        this._currentTimeline = tl;// display all win groups together
    }

    private getBetWayAnimation(winData: IBetWayWinData, winTypeName: string): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        winData.reelWinPositions.forEach((reelWin, reelId) => {
            reelWin.forEach((symWin, symId) => {
                if (symWin) {
                    tl.add(this.getSymbolWinAnimation(reelId, symId, winTypeName), 0);
                }
            });
        });
        return tl;
    }

    private getSymbolWinAnimation(reelId: number, symId: number, winTypeName: string): TimelineLite {
        const tl: TimelineLite = gsap.timeline();
        const sym: KarenSymbol = Karen.reels[reelId].getSymbol(symId, false, false);
        tl.add(() => {
            if (!this._stopped) {
                Karen.reels[reelId].reelView.addWinSymbol(sym)
            }
        }, 0.01);// no need to have win state in this game?
        const position: PIXI.Point = sym.getGlobalPosition();
        tl.add(this.playAnimation(sym!, winTypeName));
        return tl;
    }

    private playAnimation(symbol: KarenSymbol, winTypeName: string): TimelineLite {
        //details copied from oktoberfest original
        let timeline: TimelineLite = new TimelineLite();
        const postFix: string = "_toggle";
        let winType: string = winTypeName.split(' ')[0].toLowerCase();
        if (winType === "tiny" || winType === "small") {
            timeline.add(symbol.playWin("tiny" + postFix, true, 0));
        } else {
            timeline.add(symbol.playWin("win" + postFix, true, 0));
        }
        return timeline;
    }

    private getEffectLevel(winRatio: number): number {
        return 0;
    }
}
